import { useTranslation } from "react-i18next";

export type TextDirection = "ltr" | "rtl";

export const applyDocumentLanguage = (language: string, direction: TextDirection) => {
  document.documentElement.lang = language;
  document.documentElement.dir = direction;
};

export const isRtl = (element: Element = document.documentElement) =>
  getComputedStyle(element).direction === "rtl";

export const useIsRtl = () => {
  const { i18n } = useTranslation();
  return i18n.dir(i18n.language) === "rtl";
};

// In right-to-left, scrollLeft is 0 at the start and negative towards the end.
export const getScrollStart = (scroller: Element) =>
  isRtl(scroller) ? -scroller.scrollLeft : scroller.scrollLeft;

export const scrollToStart = (
  scroller: Element,
  distance: number,
  behavior: ScrollBehavior = "auto"
) => {
  scroller.scrollTo({ left: isRtl(scroller) ? -distance : distance, behavior });
};

export const scrollItemToStart = (
  scroller: Element,
  item: Element,
  behavior: ScrollBehavior = "auto"
) => {
  const scrollerBox = scroller.getBoundingClientRect();
  const itemBox = item.getBoundingClientRect();
  const offset = isRtl(scroller)
    ? itemBox.right - scrollerBox.right
    : itemBox.left - scrollerBox.left;
  scroller.scrollBy({ left: offset, behavior });
};

export const scrollItemToCenter = (
  scroller: Element,
  item: Element,
  behavior: ScrollBehavior = "auto"
) => {
  const scrollerBox = scroller.getBoundingClientRect();
  const itemBox = item.getBoundingClientRect();
  const offset = itemBox.left + itemBox.width / 2 - (scrollerBox.left + scrollerBox.width / 2);
  scroller.scrollBy({ left: offset, behavior });
};
